import { actionCreator,
  API_URL,
  checkHttpStatus,
  create_post_data,
  createRequestActionTypes,
  createSearchUrl,
  jsonApiHeader,
  showErrorMessage,
  showSuccessMessage,
  showWarningMessage,
} from '../../../../../actions/utilAction';
export { jsonApiHeader,
  actionCreator,
  checkHttpStatus,
  createSearchUrl,
  create_post_data,
  showSuccessMessage,
  showWarningMessage,
  showErrorMessage,
  API_URL,
};
export const GET_SECURITY_QUESTION = `${API_URL}/SecurityQuestions/GetSecurityQuestions`;
export const POST_SECURITY_QUESTION = `${API_URL}/SecurityQuestions/SaveSecurityQuestions`;
export const GET_SECURITY_QUESTION_BY_ID = `${API_URL}/SecurityQuestions/GetSecurityQuestionsById`;
export const DELETE_SECURITY_QUESTION = `${API_URL}/SecurityQuestions/DeleteSecurityQuestions`;

export const securityQuestionActionTypes = {
  get_security_question: createRequestActionTypes('GET_SECURITY_QUESTION'),
  post_security_question: createRequestActionTypes('POST_SECURITY_QUESTION'),
  get_security_question_by_id: createRequestActionTypes('GET_SECURITY_QUESTION_BY_ID'),
  delete_security_question: createRequestActionTypes('DELETE_SECURITY_QUESTION'),
};
export const MODULE = 'MASTER_SECURITYQUESTION';



// WEBPACK FOOTER //
// ./src/modules/Masters/components/securityQuestions/constants/ApiConstants.js